import { combineReducers } from "redux";
import history from "@utils/history";

import { connectRouter, RouterState } from "connected-react-router";
import {
  initialState as themeInitialState,
  themeReducer,
} from "@common/redux/theme/reducer";
import {
  formBuilderReducer,
  initialState as formBuilderInitialState,
} from "@common/redux/formBuilder/reducer";
import {
  formSubmissionReducer,
  initialState as formSubmissionInitialState,
} from "@common/redux/formSubmission/reducer";
import {
  formsReducer,
  initialState as formsInitialState,
} from "@common/redux/forms/reducer";

import {
  templatesReducer,
  initialState as templatesInitialState,
} from "@common/redux/templates/reducer";


import {
  foldersReducer,
  initialState as foldersInitialState,
} from "@common/redux/folders/reducer";

import {
  authReducer,
  initialState as authInitialState,
} from "@common/redux/auth/reducer";
import {
  profileReducer,
  initialState as profileInitialState,
} from "@common/redux/profile/reducer";
import {
  commonReducer,
  initialState as commonInitialState,
} from "@common/redux/common/reducer";
import {
  fileReducer,
  initialState as filesInitialState,
} from "@common/redux/upload/reducer";
import { authActions } from "@common/redux/auth/actions";
import {
  paymentInitialState,
  paymentReducer,
} from "../common/redux/payment/reducer";
import {
  subscriptionInitialState,
  subscriptionReducer,
} from "../common/redux/subscription/reducer";
import {
  publicReducer,
  initialState as publicInitialState,
} from "@common/redux/public/reducer";
import {
  initialState as adminInitialState,
  adminReducer,
} from "@common/redux/admin/reducer";
import { configReducer, initialConfigSubscriptionBundleState } from "@common/redux/config/reducer";
// import Cookies from "cookies-js";
// import { CookieStorage } from "./CookieStorage";

// const userPersistConfig = {
//   key: "auth",
//   storage: new CookieStorage(Cookies, {}),
//   whitelist: ["isAuthenticated", "authData"],
//   // blacklist: ["loaders", "errors"],
// };
// const profilePersistConfig = {
//   key: "profile",
//   storage: new CookieStorage(Cookies, {}),
//   whitelist: ["currentLoggedinUserprofileId", "profileMap"], // remove profileMap after fetch perticular profile data API is integrated.
// };

// const persistState = { _persist: { version: -1, rehydrated: true } };
// const authState = { ...authInitialState };
// const profileState = { ...profileInitialState };

const themeState = themeInitialState();
export interface IinitialState {
  router: RouterState;
  formbuilder: typeof formBuilderInitialState;
  formSubmission: typeof formSubmissionInitialState;
  adminData: typeof adminInitialState;
  forms: typeof formsInitialState;
  templates: typeof templatesInitialState;
  folders: typeof foldersInitialState;
  auth: typeof authInitialState;
  profile: typeof profileInitialState;
  files: typeof filesInitialState;
  common: typeof commonInitialState;
  public: typeof publicInitialState;
  theme: typeof themeState;
  payment: typeof paymentInitialState;
  subscription: typeof subscriptionInitialState;
  config: typeof initialConfigSubscriptionBundleState;
}

const resetToIntialState = (state: IinitialState): IinitialState => ({
  ...state,
  formbuilder: formBuilderInitialState,
  formSubmission: formSubmissionInitialState,
  adminData: adminInitialState,
  forms: formsInitialState,
  templates: templatesInitialState,
  folders: foldersInitialState,
  auth: {
    ...state.auth,
    ...authInitialState,
  },
  profile: {
    ...state.profile,
    ...profileInitialState,
  },
  files: filesInitialState,
  common: commonInitialState,
  payment: paymentInitialState,
  subscription: subscriptionInitialState,
  theme: themeInitialState(),
});
const reducer = combineReducers({
  router: connectRouter(history),
  formbuilder: formBuilderReducer,
  formSubmission: formSubmissionReducer,
  adminData: adminReducer,
  forms: formsReducer,
  templates : templatesReducer,
  folders: foldersReducer,
  auth: authReducer,
  profile: profileReducer,
  files: fileReducer,
  common: commonReducer,
  public: publicReducer,
  theme: themeReducer,
  payment: paymentReducer,
  subscription: subscriptionReducer,
  config: configReducer,
});

export default (state: IinitialState, action: any) => {
  if (action.type === authActions.LOGOUT_SUCCESS) {
    return resetToIntialState(state);
  }
  return reducer(state, action);
};
